import _extends from "@babel/runtime/helpers/extends";
import { Badge, Box, Text } from '@wix/design-system';
import React from 'react';
import s from './SearchRecommendation.module.scss';
import { RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
const mapLabelToTranslationKey = {
  [RecommendationLabel.UNKNOWN_LABEL]: null,
  [RecommendationLabel.EXACT_MATCH]: 'domain_search_suite.domain_suggestions.badge.exact_match',
  [RecommendationLabel.BEST_MATCH]: 'domain_search_suite.domain_suggestions.badge.best_match',
  [RecommendationLabel.GREAT_ALTERNATIVE]: 'domain_search_suite.domain_suggestions.badge.great_alternative',
  [RecommendationLabel.LOCAL_FAVORITE]: 'domain_search_suite.domain_suggestions.badge.local_favorite',
  [RecommendationLabel.MOST_POPULAR]: 'domain_search_suite.domain_suggestions.badge.most_popular',
  [RecommendationLabel.BEST_FOR_ECOMM]: 'domain_search_suite.domain_suggestions.badge.best_ecomm',
  [RecommendationLabel.PERFECT_FOR_YOUR_BRAND]: 'domain_search_suite.domain_suggestions.badge.perfect_brand',
  [RecommendationLabel.READY_TO_GROW]: 'domain_search_suite.domain_suggestions.badge.ready_to_grow',
  [RecommendationLabel.CREATIVE_EDGE]: 'domain_search_suite.domain_suggestions.badge.creative',
  [RecommendationLabel.PERFECT_FOR_LOCAL_REACH]: 'domain_search_suite.domain_suggestions.badge.local_reach',
  [RecommendationLabel.TRUSTED_AND_RELIABLE]: 'domain_search_suite.domain_suggestions.badge.trusted',
  [RecommendationLabel.BUILT_FOR_SUCCESS]: 'domain_search_suite.domain_suggestions.badge.built_for_success',
  [RecommendationLabel.IDEAL_FOR_SMALL_BUSINESSES]: 'domain_search_suite.domain_suggestions.badge.small_businesses',
  [RecommendationLabel.STAND_OUT_ONLINE]: 'domain_search_suite.domain_suggestions.badge.unique',
  [RecommendationLabel.GREAT_FOR_GLOBAL_REACH]: 'domain_search_suite.domain_suggestions.badge.global_reach',
  [RecommendationLabel.PERFECT_FOR_YOUR_PASSION]: 'domain_search_suite.domain_suggestions.badge.perfect_for_passion',
  [RecommendationLabel.MADE_FOR_ECOMMERCE]: 'domain_search_suite.domain_suggestions.badge.best_ecomm',
  [RecommendationLabel.INSPIRE_CONFIDENCE]: 'domain_search_suite.domain_suggestions.badge.inspire_confidence',
  [RecommendationLabel.SIMPLY_THE_BEST]: 'domain_search_suite.domain_suggestions.badge.simply_best',
  [RecommendationLabel.FIRST_CHOICE_FOR_PROFESSIONALS]: 'domain_search_suite.domain_suggestions.badge.for_pros'
};
export const Label = _ref => {
  let {
    primary,
    label,
    size = 'tiny',
    ...boxProps
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  const translationKey = mapLabelToTranslationKey[label];
  if (!translationKey) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: `${primary ? s.primaryBadge : s.badge}`
  }, boxProps), /*#__PURE__*/React.createElement(Badge, {
    skin: primary ? 'premium' : 'neutralStandard',
    size: size,
    uppercase: false
  }, /*#__PURE__*/React.createElement(Text, {
    size: size,
    weight: "normal",
    light: true
  }, t(translationKey))));
};
//# sourceMappingURL=Label.js.map